interface UploadToGCSParams {
  file: File
  path: string
  ext: string
  name?: string
  token: string
  onSuccess?: () => void
}

interface UploadResult {
  success: boolean
  error?: string
}

const UPLOAD = {
  DEV: 'http://192.168.232.128:8080/upload',
  PROD: 'https://image-uploader-feaql6ploa-uc.a.run.app/upload',
}

const getUploadEndpoint = (): string => {
  return process.env.NODE_ENV === 'production' ? UPLOAD.PROD : UPLOAD.DEV
}

/**
 * Uploads image to Google Cloud Storage
 *
 * @param file - Processed image file (after crop)
 * @param path - Storage path (e.g., 'avatars/123')
 * @param ext - File extension (e.g., 'jpg')
 * @param name - File name (e.g., 'avatar')
 * @param token - Bearer token from GENERATE_UPLOAD_TOKEN mutation
 * @returns Upload result
 */
export const uploadToGCS = async ({
  file,
  path,
  ext,
  name,
  token,
  onSuccess,
}: UploadToGCSParams): Promise<UploadResult> => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('path', path)
    formData.append('ext', ext)
    if (name) {
      formData.append('name', name)
    }

    const response = await fetch(getUploadEndpoint(), {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })

    if (!response.ok) {
      throw new Error(
        `Upload failed: ${response.status} ${response.statusText}`
      )
    }

    // Update image version in sessionStorage on success
    const newVersion = Date.now().toString()
    sessionStorage.setItem('imageVersion', newVersion)
    onSuccess?.()

    return { success: true }
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    }
  }
}
